import { render, staticRenderFns } from "./BGoogleSignIn.vue?vue&type=template&id=6e10fc69"
import script from "./BGoogleSignIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./BGoogleSignIn.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BGoogleSignIn.vue?vue&type=style&index=0&id=6e10fc69&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports